module.exports = __webpack_public_path__ + "static/lego-3f7aebd93a2ac3212fda8e57bfe911dd.gif";